export default __webpack_public_path__ + "static/media/mockupIos.1f7620dc.png";